import React, { useMemo } from 'react'
import axios from 'axios'
import FormsForm from '../../../organisms/forms/FormsForm'
import HeaderCreateForm from '../../../organisms/forms/HeaderCreateForm'
import Container from '../../../atoms/Container'
import { useHistory } from 'react-router-dom'
import { PageNavigation } from '../../../organisms/navigation/PageNavigation'
import useInstitution from '../../../../hooks/useInstitution'
import useSearchParams from '../../../../hooks/useSearchParams'
import { createFormHint } from '../../../../configs/formsConfig'
import { useAuth } from '../../../molecules/Auth'
import useOfficeHour from '../../../../hooks/services/useOfficeHour'
import { isNotSuccessful } from '../../../../hooks/useQuery'

const createForm = ({ values, config }) => axios.post('/admin/v1/forms.json', values, config)

const FormsNew = () => {
  const { user } = useAuth()
  const history = useHistory()
  const { getInstitution } = useInstitution()
  const { data: institution, status } = getInstitution()
  const searchParams = useSearchParams()
  const acceptedCivilRegistrationConditions = searchParams.get('accepted')
  const approvedTupa = searchParams.get('approvedTupa')
  const initialType = searchParams.get('type')
  const { getOfficeHour } = useOfficeHour(user.institution_id)
  const { data: officeHour, status: officeHourStatus } = getOfficeHour()

  const handleFormCreate = async ({ values, config }) => {
    try {
      const { data } = await createForm({ values, config })
      history.push(`/formularios/${data.id}/preguntas?action=new`)
    } catch (error) {
      alert('Ocurrió un error al intentar guardar.')
    }
  }

  const initialValues = useMemo(
    () => ({
      steps_attributes: [
        {
          questions_attributes: []
        }
      ],
      civil_registration_conditions: {
        accepted: acceptedCivilRegistrationConditions,
        approvedTupa
      },
      subtype: initialType || undefined,
      start_office_hour:
        officeHour?.other_forms_additional_config === 'suggested' ? null : officeHour?.other_forms_start_office_hour,
      end_office_hour:
        officeHour?.other_forms_additional_config === 'suggested' ? null : officeHour?.other_forms_end_office_hour
    }),
    [officeHour]
  )
  if (isNotSuccessful(status) || isNotSuccessful(officeHourStatus)) return null
  const config = {
    enabled_payment_methods: institution.enabled_payment_methods,
    enabled_payment_transfer_accounts_attributes: institution.payment_transfer_accounts_attributes,
    reception_desk: false,
    start_office_hour: officeHour?.other_forms_start_office_hour,
    end_office_hour: officeHour?.other_forms_end_office_hour,
    additional_config: officeHour?.other_forms_additional_config,
    has_office_hour_value: officeHour?.other_forms_enabled
  }
  const linkSteps = [`/formularios/crear/configuracion`]
  return (
    <>
      <PageNavigation />
      <Container className="pt-12">
        <HeaderCreateForm headerParams={{ activeStep: 1, hint: createFormHint.new }} linkSteps={linkSteps} />
        <FormsForm mutateForm={handleFormCreate} initialValues={initialValues} config={config} step={1} />
      </Container>
    </>
  )
}

export default FormsNew
